import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./Tooltip.css";

const Portal = ({ children }) => {
  const portal = document.getElementById("portal");
  const ele = document.createElement("div");
  useEffect(() => {
    portal.appendChild(ele);
    return () => {
      portal.removeChild(ele);
    };
  }, []);

  return createPortal(children, portal);
};

const Tooltip = ({ children, content, showOnOverflowOnly = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const [coordinates, setCoordinates] = useState({ top: 0, left: 0 });

  const ref = useRef();
  const contentRef = useRef(null);

  const getWidthFromContent = async (font) => {
    const canvas =
      getWidthFromContent.canvas ||
      (getWidthFromContent.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(content);
    return metrics.width;
  };

  const getCoordintes = async (e) => {
    const coord = e.target.getBoundingClientRect();
    const { left, top, height, width } = coord;

    let contentWidth = await getWidthFromContent("bold 12px");

    let minusWidth = 0;
    if (contentWidth > width) {
      minusWidth = contentWidth - 192;
    } else {
      minusWidth = contentWidth;
    }

    let x = Math.floor(left + width / 2 - minusWidth / 6);
    let y = Math.floor(top + height + 3);

    if (showOnOverflowOnly) {
      x = Math.floor(left);
      y = Math.floor(top + height + 3);
    }
    setCoordinates({ top: y, left: x });
    setShowTooltip(true);
  };

  const [isOverflown, setIsOverflown] = useState(false);

  useEffect(() => {
    if (contentRef?.current) {
      const element = contentRef?.current;
      setIsOverflown(
        element.scrollWidth > element.clientWidth ||
          element.scrollHeight > element.clientHeight
      );
    }
  }, [showTooltip]);

  return (
    <>
      {showTooltip && (showOnOverflowOnly ? isOverflown : true) && (
        <Portal>
          <div
            ref={ref}
            className={`absolute z-[999] tooltip-content`}
            style={{
              top: coordinates.top,
              left: coordinates.left,
            }}
          >
            <div className="bg-gray-900 text-white rounded max-w-[12rem] border-gray-700 px-2 py-1.5 text-xs font-normal whitespace-pre-line">
              {content}
            </div>
          </div>
        </Portal>
      )}

      {React.cloneElement(children, {
        ...children.props,
        ref: contentRef,
        className: `${children.props?.className || ""} cursor-pointer`,
        onMouseEnter: getCoordintes,
        onMouseLeave: () => setShowTooltip(false),
      })}
    </>
  );
};

export default Tooltip;
